// prettier-ignore
const dictionary = {
  ERROR_SETTINGS_BEGIN_HIGHER_END_HOUR:'La hora de inicio no puede ser mayor que la hora de finalización para un rango',
  ERROR_SETTINGS_BEGIN_OVERWRITE_RANGE:'La hora de inicio no puede sobrescribir un rango existente, por favor verifica los rangos en {0}',
  ERROR_SETTINGS_TO_OVERWRITE_RANGE:'La hora de finalización no puede sobrescribir un rango existente, por favor verifica los rangos en {0}',
  ERROR_SETTINGS_RANGE_IN_RANGE:'Ya existe un rango dentro del rango que estás intentando agregar, por favor verifica el rango en {0}',
  ERROR_RANGE_LEAST_HOUR:'Debes elegir un rango con al menos 1h',
  ERROR_RANGE_HALF_HOUR: 'No puedes elegir rangos con medias horas {0}',
  LABEL_SETTINGS_SELECT_OPENING_HOURS:'Indica las horas de apertura del local',
  LABEL_SETTINGS_DAY:'Día',
  LABEL_SETTINGS_FROM:'Desde',
  LABEL_SETTINGS_TO:'Hasta',
  LABEL_BUTTON_ADD:'Agregar',
  LABEL_SETTINGS_MONDAY:'Lunes',
  LABEL_SETTINGS_TUESDAY:'Martes',
  LABEL_SETTINGS_WEDNESDAY:'Miércoles',
  LABEL_SETTINGS_THURSDAY:'Jueves',
  LABEL_SETTINGS_FRIDAY:'Viernes',
  LABEL_SETTINGS_SATURDAY:'Sábado',
  LABEL_SETTINGS_SUNDAY:'Domingo',

  ERROR_ENTER_NAME: 'Por favor, ingrese su nombre',
  ERROR_ENTER_PASSWORD: 'Por favor, ingrese su contraseña',
  ERROR_USER_NOT_FOUND: 'Usuario no encontrado, por favor verifique sus credenciales',
  LABEL_ACTIVITIES_GIFT_10: 'Nuevo regalo para',
  LABEL_ACTIVITIES_LOST_GIFT: 'Regalo perdido para',
  LABEL_ACTIVITIES_LOST_POINT: 'Punto perdido para',
  LABEL_ACTIVITIES_NFC: 'Tarjeta NFC',
  LABEL_ACTIVITIES_POINT: 'Nuevo punto para',
  LABEL_ACTIVITIES_POINTS: 'Puntos',
  LABEL_ACTIVITIES_UNKNOWN_ACTION: 'Actividad no encontrada',
  LABEL_ACTIVITIES_DATE: 'Fecha',
  LABEL_ACTIVITIES_DETAIL:'Detalle',
  LABEL_ACTIVITIES_LOCAL:'Local',
  LABEL_ACTIVITIES_NO_ACTIVITIES:'No hay actividades',
  LABEL_ACTIVITIES_NO_LOCAL:'Sin local',
  LABEL_ACTIVITIES_FROM: 'Desde',
  LABEL_ACTIVITIES_TO: 'Hasta',
  LABEL_ACTIVITIES_CLEAR_FILTERS: 'Quitar filtros',
  LABEL_ALERTS_TITLE: 'Alertas',
  LABEL_ACCOUNTS_TITLE: 'Cuentas web',
  LABEL_ACCOUNTS_SUBTITLE: 'Las cuentas con contraseña del panel. Una cuenta nueva recibe una invitación para elegir su contraseña.',
  LABEL_ACCOUNTS_NEW: 'Nueva cuenta',
  LABEL_ACCOUNTS_NEW_HINT: 'Le enviaremos una invitación por correo para elegir su contraseña (válida 48 h).',
  LABEL_ACCOUNTS_EDIT: 'Editar la cuenta',
  LABEL_ACCOUNTS_ACCOUNT: 'Cuenta',
  LABEL_ACCOUNTS_COMPANY: 'Comercio',
  LABEL_ACCOUNTS_STATUS: 'Estado',
  LABEL_ACCOUNTS_INVITATION: 'Invitación',
  LABEL_ACCOUNTS_LAST_SEEN: 'Último acceso',
  LABEL_ACCOUNTS_EMAIL: 'Correo',
  LABEL_ACCOUNTS_NAME: 'Nombre',
  LABEL_ACCOUNTS_CHOOSE_COMPANY: 'Elige el comercio',
  LABEL_ACCOUNTS_CANCEL: 'Cancelar',
  LABEL_ACCOUNTS_SAVE: 'Guardar',
  LABEL_ACCOUNTS_CREATE: 'Crear y enviar la invitación',
  LABEL_ACCOUNTS_ACTIVE: 'Activa',
  LABEL_ACCOUNTS_SUSPENDED: 'Suspendida',
  LABEL_ACCOUNTS_NEVER: 'Nunca',
  LABEL_ACCOUNTS_INVITATION_ACCEPTED: 'Aceptada',
  LABEL_ACCOUNTS_INVITATION_PENDING: 'Pendiente',
  LABEL_ACCOUNTS_INVITATION_EXPIRED: 'Vencida',
  LABEL_ACCOUNTS_INVITATION_UNTIL: 'Válida hasta {0}',
  LABEL_ACCOUNTS_RESEND: 'Reenviar la invitación',
  LABEL_ACCOUNTS_SUSPEND: 'Suspender',
  LABEL_ACCOUNTS_REACTIVATE: 'Reactivar',
  LABEL_ACCOUNTS_DELETE: 'Eliminar la cuenta',
  LABEL_ACCOUNTS_DELETE_CONFIRM: 'La cuenta {0} se eliminará definitivamente.',
  LABEL_ACCOUNTS_CREATED: 'Cuenta creada, invitación enviada a {0}',
  LABEL_ACCOUNTS_SAVED: 'Cuenta guardada',
  LABEL_ACCOUNTS_INVITATION_SENT: 'Invitación enviada a {0}',
  LABEL_ACCOUNTS_DELETED: 'Cuenta {0} eliminada',
  LABEL_ACCOUNTS_ERROR: 'Algo salió mal, inténtalo de nuevo',
  LABEL_ACCOUNTS_ERROR_ACCOUNT_EXISTS: 'Ya existe una cuenta con este correo',
  LABEL_ACCOUNTS_ERROR_INVALID_EMAIL: 'Correo no válido',
  LABEL_ACCOUNTS_ERROR_COMPANY_NOT_FOUND: 'Comercio no encontrado',
  LABEL_ACCOUNTS_ERROR_INVITATION_NOT_SENT: 'La cuenta existe pero la invitación no salió: reenvíala',
  LABEL_ACCOUNTS_ERROR_ALREADY_ACCEPTED: 'Esta cuenta ya eligió su contraseña',
  LABEL_CONNECTIONS_TITLE: 'Conexiones al panel',
  LABEL_CONNECTIONS_SUBTITLE: 'Quién usa el panel web y cuándo. Una nueva visita empieza tras 30 min sin actividad.',
  LABEL_CONNECTIONS_DAYS: '{0} días',
  LABEL_CONNECTIONS_WITH_ADMINS: 'Incluir admins',
  LABEL_CONNECTIONS_ACCOUNTS: 'Cuentas',
  LABEL_CONNECTIONS_ACCOUNT: 'Cuenta',
  LABEL_CONNECTIONS_COMPANY: 'Comercio',
  LABEL_CONNECTIONS_LAST_SEEN: 'Último acceso',
  LABEL_CONNECTIONS_VISITS: 'Visitas',
  LABEL_CONNECTIONS_TIME: 'Tiempo',
  LABEL_CONNECTIONS_VISITS_TITLE: 'Visitas',
  LABEL_CONNECTIONS_SHOWING: '{0} de {1}',
  LABEL_CONNECTIONS_STARTED: 'Inicio',
  LABEL_CONNECTIONS_DURATION: 'Duración',
  LABEL_CONNECTIONS_ORIGIN: 'Origen',
  LABEL_CONNECTIONS_DEVICE: 'Navegador',
  LABEL_CONNECTIONS_VIA_LOGIN: 'Inicio de sesión',
  LABEL_CONNECTIONS_VIA_SESSION: 'Sesión abierta',
  LABEL_CONNECTIONS_NEVER: 'Nunca',
  LABEL_CONNECTIONS_AGO_MINUTES: 'hace {0} min',
  LABEL_CONNECTIONS_AGO_HOURS: 'hace {0} h',
  LABEL_CONNECTIONS_AGO_DAYS: 'hace {0} días',
  LABEL_CONNECTIONS_NO_ACCOUNTS: 'Ninguna cuenta del panel',
  LABEL_CONNECTIONS_NO_VISITS: 'Ninguna visita en este período',
  LABEL_CONNECTIONS_ERROR: 'No se pudieron cargar las conexiones',
  LABEL_ALERTS_SUBTITLE: 'Usos inusuales del sistema, detectados al dar puntos. Nunca se bloquea nada.',
  LABEL_ALERTS_TOTAL: 'alertas',
  LABEL_ALERTS_FILTER_ALL: 'Todas',
  LABEL_ALERTS_TYPE_OUTSIDE_HOURS: 'Fuera de horario',
  LABEL_ALERTS_TYPE_TWO_LOCALS: 'Dos locales',
  LABEL_ALERTS_DATE: 'Fecha',
  LABEL_ALERTS_TYPE: 'Tipo',
  LABEL_ALERTS_CUSTOMER: 'Cliente',
  LABEL_ALERTS_LOCAL: 'Local',
  LABEL_ALERTS_POINTS: 'Puntos',
  LABEL_ALERTS_DETAIL: 'Detalle',
  LABEL_ALERTS_EMPTY: 'Ninguna alerta por ahora',
  LABEL_ALERTS_DETAIL_OUTSIDE_HOURS: 'Puntos dados a las {0}, fuera del horario del día ({1})',
  LABEL_ALERTS_DETAIL_CLOSED_DAY: 'Puntos dados a las {0}, un día en que el local está cerrado',
  LABEL_ALERTS_DETAIL_TWO_LOCALS: '{0} min después de un punto en {1}',
  LABEL_DASHBOARD_HEATMAP_POINTS: 'Puntos dados',
  LABEL_DASHBOARD_HEATMAP_POINTS_UNIT: 'puntos',
  LABEL_DASHBOARD_HEATMAP_CLOSED: 'Cerrado',
  LABEL_DASHBOARD_HEATMAP_CLOSED_POINTS: 'Puntos dados fuera de horario',
  LABEL_ACTIVITIES_FILTER_ALL: 'Todos',
  LABEL_ACTIVITIES_FILTER_POINT: 'Puntos dados',
  LABEL_ACTIVITIES_FILTER_LOST_POINT: 'Puntos perdidos',
  LABEL_ACTIVITIES_FILTER_GIFT: 'Regalos dados',
  LABEL_ACTIVITIES_FILTER_LOST_GIFT: 'Regalos perdidos',
  LABEL_AUDIT_TITLE: 'Auditoría',
  LABEL_AUDIT_TOTAL: 'registros',
  LABEL_AUDIT_SEARCH: 'Buscar: usuario, IP, id, valor…',
  LABEL_AUDIT_ALL_TABLES: 'Todas las tablas',
  LABEL_AUDIT_ALL_OPERATIONS: 'Todas las operaciones',
  LABEL_AUDIT_CREATE: 'Creación',
  LABEL_AUDIT_UPDATE: 'Modificación',
  LABEL_AUDIT_DELETE: 'Eliminación',
  LABEL_AUDIT_DATE: 'Fecha',
  LABEL_AUDIT_TABLE: 'Tabla',
  LABEL_AUDIT_OPERATION: 'Operación',
  LABEL_AUDIT_RECORD: 'Registro',
  LABEL_AUDIT_CHANGES: 'Cambios',
  LABEL_AUDIT_USER: 'Usuario',
  LABEL_AUDIT_SYSTEM: 'sistema',
  LABEL_AUDIT_BEFORE: 'Antes',
  LABEL_AUDIT_AFTER: 'Después',
  LABEL_AUDIT_EMPTY: 'Ningún registro',
  LABEL_RATING_TITLE: 'Valoraciones de la app',
  LABEL_RATING_TOTAL: 'valoraciones',
  LABEL_RATING_AVERAGE: 'Promedio',
  LABEL_RATING_ALL: 'Todas',
  LABEL_RATING_LOW: '3 o menos',
  LABEL_RATING_DATE: 'Fecha',
  LABEL_RATING_NOTE: 'Nota',
  LABEL_RATING_CUSTOMER: 'Cliente',
  LABEL_RATING_ACCOUNT: 'Cuenta',
  LABEL_RATING_SHOPS: 'Tiendas',
  LABEL_RATING_LAST_VISIT: 'Última visita',
  LABEL_RATING_CONNECTIONS: 'Conexiones',
  LABEL_RATING_CONTACT: 'Contacto',
  LABEL_RATING_NO_DATE: 'Sin fecha',
  LABEL_RATING_NEVER: 'Nunca',
  LABEL_RATING_STAFF: 'Equipo',
  LABEL_RATING_NO_CONTACT: 'Sin contacto',
  LABEL_RATING_FIREBASE: 'ID para buscar en Firebase',
  LABEL_RATING_EMPTY: 'Ninguna valoración',
  LABEL_VERSIONS_TITLE: "Versiones de la app",
  LABEL_VERSIONS_ACTIVE_USERS: "usuarios activos",
  LABEL_VERSIONS_LAST_DAYS: "Últimos {0} días",
  LABEL_VERSIONS_SCOPE_ALL: "Todos los usuarios",
  LABEL_VERSIONS_SCOPE_COMPANY: "Clientes de {0}",
  LABEL_VERSIONS_ON_LATEST: "{0} de {1} en la {2}",
  LABEL_VERSIONS_STORE_UNKNOWN: "Tienda no disponible: se usa la versión más reciente vista",
  LABEL_VERSIONS_NO_DATA: "Sin datos todavía",
  LABEL_VERSIONS_HINT: "Los datos se acumulan a medida que los usuarios abren la app: cada usuario cuenta una vez, con la versión de su último uso.",
  LABEL_VERSIONS_BY_VERSION: "Por versión",
  LABEL_VERSIONS_PLATFORM: "Plataforma",
  LABEL_VERSIONS_VERSION: "Versión",
  LABEL_VERSIONS_USERS: "Usuarios",
  LABEL_VERSIONS_LAST_SEEN: "Último uso",
  LABEL_VERSIONS_BEHIND: "Usuarios con una versión anterior",
  LABEL_VERSIONS_ALL_UP_TO_DATE: "Todos están en la última versión",
  LABEL_VERSIONS_UP_TO_201: "2.0.1 o anterior",
  LABEL_VERSIONS_14X: "1.4.x (muy antigua)",
  LABEL_VERSIONS_OLDER: "Anterior a 2.0.1 (build {0})",
  LABEL_ADVERTISING_AGE: 'Edad',
  LABEL_ADVERTISING_ALERT_PICTURE: 'Por favor, confirma si deseas eliminar tu imagen',
  LABEL_ADVERTISING_CITY: 'Ciudad',
  LABEL_ADVERTISING_COUNTRY: 'País',
  LABEL_ADVERTISING_GENDER: 'Género',
  LABEL_ADVERTISING_REGION: 'Región',
  LABEL_ADVERTISING_TITLE_PICTURE: 'Eliminar imagen',
  LABEL_ADVERTISING_WARNING_CHOOSE: 'Debes elegir una opción',
  LABEL_ADVERTISING_WARNING_LOAD_IMAGE: 'Por favor, sube una imagen',
  LABEL_ADVERTISING_WEBSITE: 'Sitio web',
  LABEL_BUTTON_BACK: 'Atrás',
  LABEL_BUTTON_CANCEL: 'Cancelar',
  LABEL_BUTTON_CONFIRM: 'Confirmar',
  LABEL_BUTTON_CONTACT: 'Contáctenos',
  LABEL_BUTTON_DELETE: 'Eliminar',
  LABEL_BUTTON_RETRIEVE_PASSWORD: 'Recuperar contraseña',
  LABEL_BUTTON_SAVE: 'Guardar',
  LABEL_BUTTON_SIGNIN: 'Iniciar sesión',
  LABEL_COMPANIES_ALERT_DELETE_CONTENT: 'Vas a eliminar este negocio, por favor confirma',
  LABEL_COMPANIES_ALERT_DELETE_TITLE: 'Eliminar un negocio',
  LABEL_COMPANIES_CHANGE_PICTURE:'Cambiar la imagen',
  LABEL_COMPANIES_CODE_ERROR: 'Código debe ser 3 letras majuscule con 4 cifras',
  LABEL_COMPANIES_ERROR_IMAGE_SIZE:'Tu imagen debe tener al menos {0}px larga x {1}px alta, el tamaño de la imagen que indicaste es de {2}px larga x {3}px alta',
  LABEL_COMPANIES_FEEDBACK: 'Feedback',
  LABEL_COMPANIES_FEEDBACK_TYPE: 'Determina si se activan los feedback',
  LABEL_COMPANIES_GIFT_EXPIRATION_ERROR: 'Debe ser un numero superior a 3 días',
  LABEL_COMPANIES_GUIDE: 'Guía para imprimir',
  LABEL_COMPANIES_REPORT: 'Reporte semanal',
  LABEL_COMPANIES_REPORT_PREVIOUS_WEEK: 'Semana anterior',
  LABEL_COMPANIES_REPORT_NEXT_WEEK: 'Semana siguiente',
  LABEL_COMPANIES_REPORT_CURRENT_WEEK: 'Semana en curso',
  LABEL_COMPANIES_REPORT_ERROR: 'No se pudo generar el reporte',
  LABEL_COMPANIES_GUIDE_ERROR: 'Error al generar la guía',
  LABEL_COMPANIES_GUIDE_INCOMPLETE: 'Termina la configuración del negocio antes de generar la guía. Falta: {0}.',
  LABEL_COMPANIES_GUIDE_MISSING_GIFTS: 'los regalos',
  LABEL_COMPANIES_GUIDE_MISSING_REQUIREMENT: 'la condición para sumar un punto',
  LABEL_COMPANIES_HEADER_ACTION: 'Acción',
  LABEL_COMPANIES_HEADER_CODE: 'Código',
  LABEL_COMPANIES_HEADER_ID: 'Id',
  LABEL_COMPANIES_HEADER_COUNTRY: 'País',
  LABEL_COMPANIES_HEADER_NAME: 'Nombre negocio',
  LABEL_COMPANIES_HEADER_TYPE: 'Tipo',
  LABEL_COUNTRY: 'País',
  LABEL_COMPANIES_NAME_COMPANY_PICTURE:'El nombre de tu empresa',
  LABEL_COMPANIES_NAME_ERROR: 'El nombre debe tener entre 5 y 60 caracteres y contener solo letras, cifras o espacios',
  LABEL_COMPANIES_NO_PICTURE:'No hay imagen',
  LABEL_COMPANIES_PICTURE_MINIMUM:'Por favor sube una imagen (mínimo {0}px de largo x {1}px alto)',
  LABEL_COMPANIES_POINT_EXPIRATION_ERROR: 'Debe ser un numero superior a 3 días',
  LABEL_COMPANIES_PRIVATE: 'Privado',
  LABEL_COMPANIES_PUBLIC: 'Publico',
  LABEL_COMPANIES_REQUIREMENT_ERROR_GIFT_5:'Indica solo letras, cifras, espacios o ?!¡ con 10 caracteres mínimo',
  LABEL_COMPANIES_REQUIREMENT_ERROR_GIFT_10:'Indica solo letras, cifras, espacios o ?!¡ con 10 caracteres mínimo',
  LABEL_COMPANIES_SEARCH: 'Buscar negocios',
  LABEL_COMPANIES_TOOLTIP_CODE:'Indica el código de este negocio.',
  LABEL_COMPANIES_TOOLTIP_FACEBOOK: 'Por favor indica un vinculo de esa forma https://www.facebook.com/Fidelize',
  LABEL_COMPANIES_TOOLTIP_GIFT_EXPIRATION:'Indica cuanto tiempo van a tener tus clientes para canjear su regalo',
  LABEL_COMPANIES_TOOLTIP_INSTAGRAM: 'Por favor indica un vinculo de esa forma https://instagram.com/fidelize.chile',
  LABEL_COMPANIES_TOOLTIP_EMAIL: 'Correo al que se envían las alertas y los reportes del comercio. No se muestra a los clientes',
  LABEL_COMPANIES_TOOLTIP_NAME: 'Elije un nombre para tu empresa, este nombre se verá en la red Fidelize',
  LABEL_COMPANIES_TOOLTIP_POINT_EXPIRATION:'Indica el tiempo de inactividad necesario para perder un punto.',
  LABEL_COMPANIES_TOOLTIP_REQUIREMENT:'Indica la condición para acumular un punto.',
  LABEL_COMPANIES_TOOLTIP_GIFT:'Indica que quieres regalar por 10 puntos',
  LABEL_COMPANIES_TOOLTIP_TYPE: 'Determina si se podrá ver la empresa en la lista de la app',
  LABEL_COMPANIES_URL_FACEBOOK_ERROR:'Por favor indica un vinculo de esa forma https://www.facebook.com/Fidelize o esa forma https://www.facebook.com/share/123456',
  LABEL_COMPANIES_URL_INSTAGRAM_ERROR:'Por favor indica un vinculo de esa forma https://www.instagram.com/Fidelize',
  LABEL_COMPANIES_EMAIL_ERROR: 'Por favor indica un correo válido para las alertas y reportes',
  LABEL_CONNECTED_AS:'Estás conectado como {0}',
  LABEL_DASHBOARD_ACTIVE_CLIENTS: 'Clientes activos',
  LABEL_DASHBOARD_ACTIVE_CLIENTS_INFO: 'Clientes activos desde un mes',
  LABEL_DASHBOARD_AGE_DISTRIBUTION: 'Distribución por edad',
  LABEL_DASHBOARD_GENDER_DISTRIBUTION: 'Distribución por género',
  LABEL_DASHBOARD_GIFTS_GIVEN_W: 'Regalos otorgados (Semanal)',
  LABEL_DASHBOARD_HEATMAP_TITLE: 'Horarios de mayor actividad',
  LABEL_DAY_MON: 'Lun',
  LABEL_DAY_TUE: 'Mar',
  LABEL_DAY_WED: 'Mié',
  LABEL_DAY_THU: 'Jue',
  LABEL_DAY_FRI: 'Vie',
  LABEL_DAY_SAT: 'Sáb',
  LABEL_DAY_SUN: 'Dom',
  LABEL_DASHBOARD_LOCAL_DISTRIBUTION_W: 'Puntos otorgados por local (Semanal)',
  LABEL_DASHBOARD_LOCAL_DISTRIBUTION_TOTAL: 'Puntos otorgados por local (Total)',
  LABEL_DASHBOARD_NOTIFICATIONS_W: 'Notificaciones enviadas (Semanal)',
  LABEL_NOTIFICATIONS_POINT: 'Aviso de puntos',
  LABEL_NOTIFICATIONS_GIFT: 'Aviso de regalos',
  LABEL_DASHBOARD_POINT_CONVERSION: 'Retorno tras aviso (puntos)',
  LABEL_DASHBOARD_POINT_CONVERSION_INFO: '% que volvió tras el aviso, antes de perder el punto',
  LABEL_DASHBOARD_GIFT_CONVERSION: 'Retorno tras aviso (regalos)',
  LABEL_DASHBOARD_GIFT_CONVERSION_INFO: '% que canjeó tras el aviso, antes de que expirara',
  LABEL_DASHBOARD_RETENTION: 'Retención de puntos',
  LABEL_DASHBOARD_RETENTION_INFO: '% de puntos renovados en vez de expirados, en todos sus clientes',
  LABEL_DASHBOARD_RATES_TITLE: 'Evolución de indicadores',
  LABEL_DASHBOARD_RETENTION_CHART_TITLE: 'Evolución de retención',
  LABEL_DASHBOARD_RETURNS_CHART_TITLE: 'Evolución de retornos',
  LABEL_DASHBOARD_TOP_CLIENTS: 'Clientes más fieles',
  LABEL_DASHBOARD_TOP_CLIENTS_GIFTS: 'regalo|regalos',
  LABEL_DASHBOARD_TOP_CLIENTS_REDEEMED: 'canjeado|canjeados',
  LABEL_DASHBOARD_TOP_CLIENTS_EXPIRED: 'expirado|expirados',
  LABEL_DASHBOARD_TOP_CLIENTS_PENDING: 'pendiente|pendientes',
  LABEL_DASHBOARD_TOP_CLIENTS_NO_GIFTS: 'Sin regalos aún',
  LABEL_DASHBOARD_TOP_CLIENTS_ANONYMOUS: 'Cliente',
  LABEL_DASHBOARD_TAB_OVERVIEW: 'Resumen',
  LABEL_DASHBOARD_TAB_LOYALTY: '¿Vuelven mis clientes?',
  LABEL_DASHBOARD_TAB_CLIENTS: '¿Quiénes son mis clientes?',
  LABEL_DASHBOARD_TAB_LOCALS: '¿Qué local rinde más?',
  LABEL_DASHBOARD_ENTRY_DISTRIBUTION: 'Distribución por método de entrada',
  LABEL_DASHBOARD_ENTRY_NFC: 'NFC',
  LABEL_DASHBOARD_ENTRY_SCAN: 'Escaneo',
  LABEL_DASHBOARD_ENTRY_CODE: 'Código',
  LABEL_DASHBOARD_ENTRY_UNKNOWN: 'Desconocido',
  LABEL_DASHBOARD_MAN: 'Hombre',
  LABEL_DASHBOARD_NEW_CLIENTS: 'Nuevos clientes',
  LABEL_DASHBOARD_NEW_CLIENTS_INFO: 'Nuevos clientes desde un mes',
  LABEL_DASHBOARD_NOT_DEFINED: 'No definido',
  LABEL_DASHBOARD_NO_DATA: 'Sin datos',
  LABEL_DASHBOARD_NUMBER_OF_CLIENTS: 'Número de clientes',
  LABEL_DASHBOARD_NUM_USUARIOS: 'Numero de usuarios',
  LABEL_DASHBOARD_NUM_USUARIOS_INFO: 'Numero total de usuarios desde el principio',
  LABEL_DASHBOARD_POINTS_GIVEN: 'Puntos otorgados',
  LABEL_DASHBOARD_POINTS_GIVEN_W: 'Puntos otorgados/perdidos (Semanal)',
  LABEL_DASHBOARD_POINTS_TITLE: 'Puntos otorgados/perdidos',
  LABEL_DASHBOARD_POINTS_USERS_W: 'Nuevos usuarios (Semanal)',
  LABEL_VIEW_WEEKLY: 'Semanal',
  LABEL_VIEW_MONTHLY: 'Mensual',
  LABEL_VIEW_ALL_TIME: 'Total',
  LABEL_COMPANIES_REQUIREMENT_ERROR: 'Indicar solo letras, numeros y espacios',
  LABEL_DASHBOARD_TOTAL_CLIENTS: 'Clientes total',
  LABEL_DASHBOARD_TOTAL_CLIENTS_INFO: 'Clientes total desde el principio',
  LABEL_DASHBOARD_W: 'S',
  LABEL_DASHBOARD_WOMAN: 'Mujer',
  LABEL_FEEDBACKS_HEADER_DATE: 'Fecha',
  LABEL_FEEDBACKS_HEADER_MESSAGE: 'Mensaje',
  LABEL_FEEDBACKS_HEADER_NOTE: 'Nota',
  LABEL_FEEDBACKS_HEADER_USER: 'Nombre de usuario',
  LABEL_FEEDBACKS_SEARCH: 'Buscar retroalimentaciones',
  LABEL_IMAGE_REQUIREMENT: 'Tu imagen debe tener una relación de aspecto 2/3 (vertical) o 3/2 (horizontal) y menos de 2MB',
  LABEL_INPUT_CARD_EXPIRATION: 'Expiración de la(s) tarjeta(s) (días)',
  LABEL_INPUT_CODE: 'Código',
  LABEL_INPUT_FACEBOOK_URL: 'URL de Facebook',
  LABEL_INPUT_GIFT_EXPIRATION: 'Expiración del regalo (días)',
  LABEL_INPUT_IMAGE: 'Imagen',
  LABEL_INPUT_INSTAGRAM_URL: 'URL de Instagram',
  LABEL_INPUT_COMPANY_EMAIL: 'Correo de alertas y reportes',
  LABEL_INPUT_MAIL: 'Correo',
  LABEL_INPUT_NAME: 'Nombre',
  LABEL_INPUT_NO_IMAGE: 'No hay imagen',
  LABEL_INPUT_PASSWORD: 'Contraseña',
  LABEL_INPUT_REQUIREMENT: 'Requisito',
  LABEL_INPUT_GIFT_5: 'Regalo 5 puntos',
  LABEL_INPUT_GIFT_TITLE: 'Titulo regalo',
  LABEL_INPUT_GIFT_DESC: 'Descripción',
  LABEL_INPUT_GIFT_10: 'Regalo 10 puntos',
  LABEL_NO_GIFT_AT_CREATION: 'Por favor crea el negocio primero y después podrás indicar los regalos',
  LABEL_INPUT_USERNAME: 'Nombre de usuario',
  LABEL_LOCALS_ADDRESS:'Dirección',
  LABEL_LOCALS_ADDRESS_ERROR: 'La dirección debe tener entre 5 y 60 caracteres y contener solo letras, cifras o espacios',
  LABEL_LOCALS_ADDRESS_ID:'Address Id',
  LABEL_LOCALS_ADDRESS_ID_ERROR: 'Debe ser un id de google maps, por ejemplo AKHwGeGYTcMbo5Hn6',
  LABEL_LOCALS_ADDRESS_ID_TOOLTIP: 'Recupera el address id de la pagine google',
  LABEL_LOCALS_ADDRESS_TOOLTIP: 'La dirección como va aparecer en la app',
  LABEL_LOCALS_ALERT_DELETE_CONTENT: 'Vas a eliminar este dirección, por favor confirma',
  LABEL_LOCALS_ALERT_DELETE_TITLE: 'Eliminar una dirección',
  LABEL_ACTIVITY_ALERT_DELETE_CONTENT: 'Vas a eliminar esta actividad, por favor confirma',
  LABEL_ACTIVITY_ALERT_DELETE_TITLE: 'Eliminar una actividad',
  LABEL_LOCALS_HEADER_ACTIONS: 'Acción',
  LABEL_LOCALS_HEADER_ADDRESS: 'Dirección',
  LABEL_LOCALS_HEADER_NAME: 'Nombre visible',
  LABEL_LOCALS_HEADER_PHONE_NUMBER: 'Número de teléfono',
  LABEL_LOCALS_NAME:'Nombre',
  LABEL_LOCALS_NAME_ERROR: 'El nombre debe tener entre 5 y 30 caracteres y contener solo letras, cifras o espacios',
  LABEL_LOCALS_NAME_TOOLTIP: 'El nombre que se va a ver en la app por este local',
  LABEL_LOCALS_PHONE:'Teléfono',
  LABEL_LOCALS_PHONE_ERROR: 'El teléfono de contacto debe ser de forma tel:+56973123570 o whatsapp:+56973123570',
  LABEL_LOCALS_PHONE_TOOLTIP: 'El teléfono de contacto por este local, por favor usa whatsapp: o tel:',
  LABEL_LOCALS_SEARCH: 'Buscar locales',
  LABEL_NO:'No',
  LABEL_NOTIFICATION_ACTION: 'Acción',
  LABEL_NOTIFICATION_ALERT_DELETE_CONTENT: 'Vas a eliminar esta notificación, por favor confirma',
  LABEL_NOTIFICATION_ALERT_DELETE_TITLE: 'Eliminar una notificación',
  LABEL_NOTIFICATION_ANSWER: 'Respuesta',
  LABEL_NOTIFICATION_ANSWER_DESC: 'Indica posibles respuestas',
  LABEL_NOTIFICATION_ANSWER_ERROR: 'Debes indicar entre 2 y 5 respuestas (con 5 hasta 20 caracteres)',
  LABEL_NOTIFICATION_CONTENT: 'Contenido',
  LABEL_NOTIFICATION_CONTENT_DESC: 'Luego escribe el contenido',
  LABEL_NOTIFICATION_CONTENT_ERROR: 'El contenido debe tener entre 10 y 100 caracteres y contener solo letras, cifras o espacios',
  LABEL_NOTIFICATION_CREATED: 'La notificación ha sido creada',
  LABEL_NOTIFICATION_DATE: 'Fecha',
  LABEL_NOTIFICATION_DATE_DESC: 'Y selecciona la fecha y hora en la que deseas enviarla',
  LABEL_NOTIFICATION_DATE_ERROR: 'Por favor, selecciona una fecha y hora para enviar notificaciones',
  LABEL_NOTIFICATION_NO_DATE: 'Sin fecha',
  LABEL_NOTIFICATION_NO_NOTIFICATION: 'No hay notificaciones, por favor crea la primera',
  LABEL_NOTIFICATION_STANDARD: 'Estándar',
  LABEL_NOTIFICATION_STATUS: 'Estado',
  LABEL_NOTIFICATION_SURVEY: 'Encuesta',
  LABEL_NOTIFICATION_TITLE: 'Título',
  LABEL_NOTIFICATION_TITLE_DESC: 'Por favor, elige un título para la notificación',
  LABEL_NOTIFICATION_TITLE_ERROR: 'El título debe tener entre 5 y 60 caracteres y contener solo letras, cifras o espacios',
  LABEL_NOTIFICATION_TOOLTIP_ANSWER: 'Presiona la tecla enter/return para agregar tu respuesta',
  LABEL_NOTIFICATION_TOOLTIP_DATE: 'No puedes elegir en la próxima hora, por favor indica algo después',
  LABEL_NOTIFICATION_TOOLTIP_TYPE: 'El tipo estándar es un mensaje de notificación simple, las encuestas son preguntas y necesitarás indicar posibles respuestas',
  LABEL_NOTIFICATION_TYPE: 'Tipo',
  LABEL_NOTIFICATION_UPDATED: 'La notificación ha sido actualizada',
  LABEL_NO_RESULTS:'No hay resultados',
  LABEL_POINTS_GAINED: 'Puntos otorgados',
  LABEL_POINTS_LOST: 'Puntos perdidos',
  LABEL_PRICING_BASIC_FEATURE_1: 'Acceso al módulo de administración',
  LABEL_PRICING_BASIC_FEATURE_2: 'Gestiona la configuración de tu empresa',
  LABEL_PRICING_BASIC_FEATURE_3: 'Gestiona tus usuarios (máx. 2 usuario)',
  LABEL_PRICING_BASIC_FEATURE_4: 'Visualiza tus retroalimentaciones',
  LABEL_PRICING_BASIC_FEATURE_5: 'Soporte básico',
  LABEL_PRICING_BASIC_TITLE: 'Plan Básico',
  LABEL_PRICING_CHOSE_PLAN: 'Elige tu plan mensual',
  LABEL_PRICING_OBJECT_INTERESTED: 'Interesado en',
  LABEL_PRICING_PREMIUM_FEATURE_1: 'Incluye el plan estándar',
  LABEL_PRICING_PREMIUM_FEATURE_2: 'Hasta 3 Locales',
  LABEL_PRICING_PREMIUM_FEATURE_3: '10 Notificaciones',
  LABEL_PRICING_PREMIUM_FEATURE_4: '1 Encuesta',
  LABEL_PRICING_PREMIUM_FEATURE_5: 'Análisis avanzados (Distribución por género y edad)',
  LABEL_PRICING_PREMIUM_FEATURE_7: 'Soporte prioritario',
  LABEL_PRICING_PREMIUM_FEATURE_8: '3 Tarjetas NFC',
  LABEL_PRICING_PREMIUM_COMMENT:'Cada tarjeta NFC adicional: 7.500 CLP (pago único)',
  LABEL_PRICING_PREMIUM_TITLE: 'Plan Premium',
  LABEL_PRICING_SCALED_PLAN: 'Plan escalado',
  LABEL_PRICING_STANDARD_FEATURE_1: 'Incluye el plan básico',
  LABEL_PRICING_STANDARD_FEATURE_2: 'Número ilimitado de usuarios',
  LABEL_PRICING_STANDARD_FEATURE_3: 'Hasta 1 Local',
  LABEL_PRICING_STANDARD_FEATURE_4: '4 Notificaciónes',
  LABEL_PRICING_STANDARD_FEATURE_5: 'Análisis básicos (Puntos, Regalos, Clientes activos, Nuevos clientes)',
  LABEL_PRICING_STANDARD_FEATURE_6: 'Publicidad en el Instagram Fidelize',
  LABEL_PRICING_STANDARD_FEATURE_7: 'Soporte estándar',
  LABEL_PRICING_STANDARD_FEATURE_8: 'La tarjeta NFC Fidelize',
  LABEL_PRICING_STANDARD_COMMENT:'Cada tarjeta NFC adicional: 15.000 CLP (pago único)',
  LABEL_PRICING_STANDARD_TITLE: 'Plan Estándar',
  LABEL_RESET_DEFINE_DONE:'La contraseña ha sido cambiada exitosamente, te vamos a redirigir para identificarte',
  LABEL_RESET_DEFINE_PASSWORD_CONTENT:'Por favor indica tu nueva contraseña y repítela por favor',
  LABEL_RESET_DEFINE_PASSWORD_TITLE:'Definir nueva contraseña',
  LABEL_RESET_ERROR_VERIFY:'Por favor verifica los campos',
  LABEL_RESET_GLOBAL_ERROR: 'Hubo un error en el proceso, por favor inténtalo nuevamente',
  LABEL_RESET_PASSWORD_1:'Nueva contraseña',
  LABEL_RESET_PASSWORD_1_ERROR:'Tu contraseña debe contener 6 caracteres mínimo y contener a lo menos una letra, una cifra y un carácter especial',
  LABEL_RESET_PASSWORD_2:'Confirmación de contraseña',
  LABEL_RESET_PASSWORD_2_ERROR:'Por favor repite tu nueva contraseña',
  LABEL_RESET_PASSWORD_CONTENT:'No hay problema solo indica tu correo y te mandamos un vinculo para reiniciarlo',
  LABEL_RESET_PASSWORD_MAIL_ERROR: 'Por favor indica un mail válido',
  LABEL_RESET_PASSWORD_RESET_DONE: 'Si este correo corresponde a una cuenta, recibirás un enlace para reiniciar tu contraseña. Revisa también tu carpeta de spam.',
  LABEL_RESET_PASSWORD_TITLE:'Olvidaste tu contraseña ?',
  LABEL_USERS_HEADER_ACTIONS: 'Acción',
  LABEL_USERS_HEADER_CONNECTIONS: 'Conexiones',
  LABEL_USERS_HEADER_DOB: 'Fecha nacimiento',
  LABEL_USERS_HEADER_GENDER: 'Genero',
  LABEL_USERS_HEADER_NAME: 'Nombre visible',
  LABEL_USERS_HEADER_PLATFORM: 'Plataforma',
  LABEL_USERS_HEADER_STATUS: 'Estado',
  LABEL_USERS_SEARCH: 'Buscar usuarios',
  LABEL_WARNING_ADVERTISING: 'Por favor, complete el formulario de publicidad para activar la funcionalidad',
  LABEL_YES: 'Si',
};
export default dictionary;
